import Input from "components/Input";
import Text from "components/Text";
import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useLeaveTypes } from "repositories/leave-repository";
import styles from "../staff.module.scss";

const LeavesInput = ({
  leaves,
  onChange,
  t,
  inputChange,
  vacationPaidOff,
  resetValues,
}) => {
  const { data: apiRes, isLoading, error } = useLeaveTypes();

  // leaves prop can be an empty array. So we have to
  // fill it with default values.
  useEffect(() => {
    if (
      !isLoading &&
      apiRes &&
      apiRes.data &&
      apiRes.data.leave_type &&
      apiRes.data.leave_type.length !== leaves.length
    ) {
      const leaveTypes = apiRes.data.leave_type;
      let newLeaves = [...leaves];

      for (let i = 0; i < leaveTypes.length; i++) {
        if (newLeaves.findIndex((l) => l.typeId === leaveTypes[i].id) > -1)
          continue;

        newLeaves.push({
          typeId: leaveTypes[i].id,
          value: resetValues ? "" : "0",
          error: "",
        });
      }

      onChange(newLeaves);
    }
    // eslint-disable-next-line
  }, [leaves, isLoading, apiRes]);

  if (isLoading) return null;

  if (
    error ||
    (!isLoading && !apiRes) ||
    (!isLoading && apiRes.statusCode !== 200) ||
    (!isLoading && !apiRes.data) ||
    (!isLoading && !apiRes.data.leave_type)
  ) {
    return "Could not load leave types!";
  }

  const leaveInputs = apiRes?.data?.leave_type?.map((it) => {
    let leave = leaves.find((l) => l.typeId === it.id);

    let value = "0";
    let _error = "";
    if (leave) {
      value = leave.value;
      _error = leave.error;
    }

    return (
      <Input
        HelperLabelClass={"no-wrap-field"}
        key={it.id}
        Title={it.name + " " + t("form.fields.leaves")}
        Type="text"
        MaxLength={3}
        Value={value}
        Error={_error}
        HelperLabel={<strong>{t("accountOwner.daysPerYear")}</strong>}
        HandleChange={(e) => {
          const v = e.target.value;

          const i = leaves.findIndex((l) => l.typeId === it.id);
          if (i > -1) {
            leaves.splice(i, 1);
          }

          onChange([...leaves, { typeId: it.id, value: v, error: _error }]);
        }}
      />
    );
  });

  return (
    <div
      className={`bg-white ${styles["mb-10"]} ${styles["inline-form-space-fix"]} ${styles["p-20"]} ${styles["rounded-6"]}`}
    >
      <Text
        size="15px"
        weight="600"
        color="#2D3245"
        className={`${styles["form-title"]}`}
      >
        Leave & Time Off
      </Text>
      <Input
        Title={"Vacation / Paid Time Off"}
        Type="text"
        Placeholder={"0"}
        Name={"vacationPaidOff"}
        MaxLength={100}
        HandleChange={inputChange}
        // HelperLabel={<strong>{t("superAdmin.cad")}</strong>}
        Value={vacationPaidOff}
      />
      {leaveInputs || null}
    </div>
  );
};

export default withTranslation()(LeavesInput);
